module.exports = __webpack_public_path__ + "static/tereza-0880518455ef544d58b5c34e6d7af6ff.jpeg";